//import Footer from "./components/footer/Footer";
//import Navbar from "./components/navbar/Navbar";
import Home from "./pages/home/home";

import AboutUs from "./pages/aboutUs/AboutUs";
import { Route,Routes } from "react-router-dom"
import ArticlePage from "./pages/articlePage/ArticlePage";
import CreateArticle from "./pages/createArticle/CreateArticle";
import NotFound from "./pages/notFound/NotFound";
//propt vorodi be component
function App() {
  
  return (
    <div className="App">
     
      {/* <Navbar title="سایت عوض نیا" />  
      npx json-server --watch data/db.json --port 8000
      ساخت api و ایجاد پوشه data و فایل json*/}
      {/* <Navbar title=" عوض نیا" /> */}
      {/* <Footer/> */}
      <Routes>
             <Route path="*" element={<NotFound />}/>
          <Route path="/" element={<Home />}/>
          <Route path="/about" element={<AboutUs    />} />
          <Route path="/article/:id" element={<ArticlePage    />} />
          <Route path="/create-article" element={<CreateArticle    />} />

          </Routes>
      

      
    </div>
  );
}



export default App;
